import useModal from './useModal.js';

export default useModal;
